// Permission-based page wrapper component
// Automatically checks permissions and redirects if user doesn't have access

import React from 'react';
import { usePermissions } from '../contexts/PermissionContext';
import { canAccessPage } from '../utils/permissionChecker';

const PermissionPage = ({ 
  pageKey, 
  children, 
  fallback = null,
  redirectTo = 'profile' 
}) => {
  const { loading, hasPermission } = usePermissions();
  
  // Show loading while permissions are being loaded
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
      </div>
    );
  }
  
  // Check if user can access this page
  const hasAccess = canAccessPage(pageKey, hasPermission);
  
  if (!hasAccess) {
    if (fallback) {
      return fallback;
    }
    
    // Default fallback - show access denied message
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="text-6xl mb-4">🚫</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-4">
            You don't have permission to access this page.
          </p>
          <p className="text-sm text-gray-500">
            Contact your administrator if you believe this is an error.
          </p>
        </div>
      </div>
    );
  }
  
  return children;
};

export default PermissionPage;
